import { type QueryClient } from '@tanstack/react-query';

import { getGetMyVouchersQueryKey } from '@/api/gen/vouchers/vouchers.gen';
import { UseSubscribeUserPlanKey } from '@/lib/auth';

/** 이용권 활성화 직후 플랜·이용권 UI가 같은 서버 상태를 보게 한다. */
export const refreshVoucherActivationState = (queryClient: QueryClient) =>
  Promise.allSettled([
    queryClient.refetchQueries({ queryKey: UseSubscribeUserPlanKey }),
    queryClient.invalidateQueries({ queryKey: getGetMyVouchersQueryKey() }),
  ]);
